import request from 'superagent';
import ActionTypes from 'app/action-types';
import config from 'app/config';

export default ({ username, password }) => dispatch => {
  dispatch({
    type: ActionTypes.USER_LOGIN_BEGIN,
  });

  return new Promise((resolve, reject) => {
    const host = config.get('AUTH_HOST');

    request
      .post(`${host}/v1/login/email`)
      .send({ email: username, password })
      .end((err, res) => {
        if (err) {
          dispatch({
            type: ActionTypes.USER_LOGIN_FAIL,
            error: err,
          });
          return reject(err);
        }

        dispatch({
          type: ActionTypes.USER_LOGIN_SUCCESS,
          result: res.body,
        });

        return resolve(res);
      });
  });
};
